export default "__VITE_PUBLIC_ASSET__c5ac7f57__"